module.exports = __webpack_public_path__ + "static/Organic-yoghurt-a51452b82bee7d3230d68058e6903710.png";